import { useFormSubmit } from "@/hooks/useFormSubmit";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahgpa3oh653ivfvnur0";

export default function SubscribeForm({ variant = "light" }: { variant?: "light" | "dark" }) {
  const { status, message, handleSubmit } = useFormSubmit(SUBMIT_ADDR, "website_alt");
  const dark = variant === "dark";

  return (
    <form
      id="subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <label className="sr-only" htmlFor="subscribe-email">
          邮箱地址
        </label>
        <input
          id="subscribe-email"
          name="email"
          type="email"
          required
          autoComplete="email"
          placeholder="留下邮箱，第一时间收到最新瓜线"
          className={`flex-1 h-12 px-4 rounded-md text-sm border outline-none transition-colors ${
            dark
              ? "bg-background-50/10 border-background-50/30 text-background-50 placeholder:text-background-300 focus:border-accent-400"
              : "bg-background-50 border-background-300 text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          }`}
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className={`h-12 px-6 rounded-md text-sm font-medium transition-colors whitespace-nowrap disabled:opacity-60 ${
            dark
              ? "bg-accent-500 text-foreground-950 hover:bg-accent-400"
              : "bg-primary-500 text-background-50 hover:bg-primary-600"
          }`}
        >
          {status === "loading" ? "提交中…" : "订阅围观提醒"}
        </button>
      </div>

      <label className="note-aux-clip" aria-hidden="true">
        公司备用联系
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          readOnly
          aria-hidden="true"
        />
      </label>

      {message ? (
        <p
          role="status"
          className={`mt-3 text-sm flex items-center gap-2 ${
            status === "error" ? "text-primary-600" : dark ? "text-accent-300" : "text-secondary-700"
          }`}
        >
          <i
            className={`${
              status === "error" ? "ri-error-warning-line" : "ri-checkbox-circle-line"
            } w-4 h-4 flex items-center justify-center`}
          ></i>
          {message}
        </p>
      ) : null}
      <p className={`mt-3 text-xs ${dark ? "text-background-300" : "text-foreground-500"}`}>
        我们只会用它发送热点更新与聊天室提醒，随时可以退订。
      </p>
    </form>
  );
}